import './Loader.scss';

const Loader = props => (
  <div className="loader">
    <div className="loader__spinner" />
  </div>
);

export default Loader;
